export default class SlidesBoForm extends HTMLDivElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initEvents();

        this.displayInputFile($('#type_file').val());
    }

    initEvents() {
        var localThis = this;

        $("#type_file").on('change', function(e) {
            localThis.displayInputFile($(this).val());
        });
    }

    displayInputFile(type) {
        let $visual = $('#visual_slide');

        if (type == 10) {
            $('.form_video_link').addClass('hide');
            $('.form_input_file').removeClass('hide');
            $('#video_link').prop('required', false);

            if(!$visual.data('initial-preview'))
                $visual.prop('required', true);

        }

        if (type == 20) {
            $('.form_input_file').addClass('hide');
            $('.form_video_link').removeClass('hide');

            $visual.prop('required', false);

            $('#video_link').prop('required',true);
        }
    }
}